/**
 * index.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Import all the third party stuff
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Provider, useDispatch } from 'react-redux'
import { BrowserRouter, Switch, Redirect, Route } from 'react-router-dom'

import { Offline, Online } from './components/connectivity'

import { SnackbarProvider } from 'notistack'

// persist
import { PersistGate } from 'redux-persist/integration/react'

// store
import { store, persistor } from './configureStore'

// Import routes
import rootRoutes from './routes'

// error pages
import { NotFoundPage, ErrorBoundary } from './components/error-pages'

import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider,
  LayoutSplashScreen,
  MaterialThemeProvider
} from './components/layout'

import { ContentRoute } from './components/router'

// load translation
import { MetronicI18nProvider, I18nProvider, isRLTLang } from './i18n'

// load main style
import './assets/scss/main.scss'

import { OidcProvider } from '@axa-fr/react-oidc';
import { CLIENT_ID } from './constants'
import { API_BASE_URL_AUTH, SESSION_COOKIE_NAME } from "./constants";
import { login, loginSuccess } from "./modules/authentication/store/actions";
import { ACTIONS } from './modules/authentication/store/constants'
// load style
const App = () => {
  const [authChecked, setAuthChecked] = useState(false);
  const [authorized, setAuthorized] = useState(false);
  const dispatch = useDispatch()
useEffect(() => {
  const checkAuth = async () => {
    try {

      const res = await fetch(`${API_BASE_URL_AUTH}/sc/ms1/api/auth/me`, {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-Session-ID": SESSION_COOKIE_NAME,
          "X-Project-Name": "evax_ii"
        },
      });

      console.log("*********res",res,res.status)

      if (res.status === 401) {
        console.log("*********res.status",res.status,`${API_BASE_URL_AUTH}/sc/ms1/oidc/authenticate-evax/?post_login_url=` + window.location.origin)
        // Not logged in → redirect to Keycloak login
        window.location.href = `${API_BASE_URL_AUTH}/sc/ms1/oidc/authenticate-evax/?post_login_url=` + window.location.origin;
        return;
      } else if (res.status === 200) {
        const data = await res.json(); // parse body as JSON
        console.log({data})
        dispatch(login(data));
        if (!sessionStorage.getItem("namespaceModalShown")) {
          dispatch(loginSuccess(data));
          sessionStorage.setItem("namespaceModalShown", "true");
        }
        console.log(data);
        setAuthorized(true);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setAuthChecked(true);
    }
  };

  checkAuth();
}, [dispatch]);


  if (!authChecked) return <LayoutSplashScreen />;

  if (!authorized) return null;

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <SnackbarProvider maxSnack={3}>
          <Switch>
            {Object.keys(rootRoutes).map((key, i) => (
              <ContentRoute key={i} {...rootRoutes[key]} />
            ))}
            <Redirect exact from="/" to={rootRoutes.admin.path} />
            <Route component={NotFoundPage} />
          </Switch>
        </SnackbarProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};


if (process.env.NODE_ENV == 'production') {
  // console.log = () => {}
  // console.error = () => {}
  // console.debug = () => {}
}
 
if (isRLTLang()) {
   const BODY_NODE = document.getElementsByTagName('body')[0]
   BODY_NODE.setAttribute('direction', 'rtl')
   BODY_NODE.setAttribute('dir', 'rtl')
   BODY_NODE.setAttribute('style', "direction: rtl;font-family: 'big-vesta', 'Poppins';")
 }

 
 let client_id = CLIENT_ID
 let configuration = {
    client_id: client_id,
    redirect_uri:  window.location.origin + '/signin-oidc',
    scope: 'openid profile jwtapitestapp.read',
    service_worker_only:true,
  };

  if(client_id){
    configuration = {
      client_id: client_id,
      redirect_uri:  window.location.origin + '/signin-oidc',
      scope: 'openid profile jwtapitestapp.read',
      authority: 'https://oauth.server.ordre-medecins.tn',
      service_worker_only:true,
    };

  }

  console.log("*****configuration******",configuration)

const MOUNT_NODE = document.getElementById('root')
const ELEM = (
  <OidcProvider configuration={configuration} >
    <MetronicI18nProvider>
      <MetronicLayoutProvider>
        <MetronicSubheaderProvider>
          <MetronicSplashScreenProvider>
            <Provider store={store}>
              <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
                <MaterialThemeProvider>
                  <I18nProvider>
                    <Online>
                      <React.Suspense fallback={<LayoutSplashScreen />}>
                        <App />
                      </React.Suspense>
                    </Online>
                    <Offline />
                  </I18nProvider>
                </MaterialThemeProvider>
              </PersistGate>
            </Provider>
          </MetronicSplashScreenProvider>
        </MetronicSubheaderProvider>
      </MetronicLayoutProvider>
    </MetronicI18nProvider>
  </OidcProvider>
)

ReactDOM.render(ELEM, MOUNT_NODE)

if (process.env.NODE_ENV !== 'production' && module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['./routes'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE).render(ELEM, MOUNT_NODE)
  })
}
